import { useApiClient, useFetch } from '@marageti/z4-lib';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Partner, PartnerProfileUpdate } from '@marageti/z4-sdk/lib/travel/Partner';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { SubmitHandler, FieldValues } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import EditCapacityView from './edit-capacity-view';
import { ContainerProps } from './types';

const EditCapacityContainer = ({
  open,
  onClose,
}: ContainerProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { partnerId } = useParams();
  const apiClient = useApiClient();
  const [submissionError, setSubmissionError] = useState<ApiError>();

  const { data: partner, mutate: mutatePartner } = useFetch<Partner>(apiClient.partnersClient.getPartner, [partnerId], !!partnerId);

  const handleCancel = () => {
    onClose();
  };

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    if (partner) {
      const updatedPartnerProfile: PartnerProfileUpdate = {
        id: partner.id,
        capacity: Number(data.capacity),
        notes: partner.notes,
        partnerReferralProgram: partner.partnerReferralProgram,
      };
      try {
        await apiClient.partnersClient.putPartnerProfile(partner.id, updatedPartnerProfile);
        mutatePartner();
        enqueueSnackbar('Max Capacity updated.', { variant: 'success' });
        onClose();
      } catch (error) {
        setSubmissionError(error as ApiError);
        enqueueSnackbar('An error occurred during the update.', { variant: 'default' });
      }
    }
  };

  return (
    <EditCapacityView
      onCancel={handleCancel}
      onSubmit={onSubmit}
      open={open}
      submissionError={submissionError}
      partner={partner}
    />
  );
};

export default EditCapacityContainer;
